import { Box } from '@nimbus-ds/components';
import { useResponsive } from 'commons/components';
import { STYLE_STATS_DAILY_TAB_CONTENT } from './StatsDailyTabContent';
import StatsDailyValueCard from './StatsDailyValueCard';

function Skeleton() {
  const { isMobile } = useResponsive();

  return (
    <Box
      {...STYLE_STATS_DAILY_TAB_CONTENT}
      gridTemplateColumns={!isMobile ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)'}
    >
      <StatsDailyValueCard.Skeleton />
      <StatsDailyValueCard.Skeleton />
      <StatsDailyValueCard.Skeleton />
      <StatsDailyValueCard.Skeleton />
    </Box>
  );
}

export default Skeleton;
